import React, {useEffect, useMemo, useRef, useState} from "react";
import styles from './DeliveryItem.module.css'
import logoPost from '../../Img/Delivery/logoPost.png'
import logoSim from '../../Img/Delivery/logoSim.png'
import logoCdek from '../../Img/Delivery/logoCdek.png'
import logoSelf from '../../Img/Delivery/logoSelf.png'
import logoNo from '../../Img/Delivery/logoNo.png'
import logoEsim from '../../Img/Delivery/logoEsim.png'
import logoMarker from '../../Img/Delivery/logoMarker.png'
import yaMarker from '../../Img/Delivery/yaMarkerBlack.png'
import simFull from '../../Img/Delivery/simFull.png'

import logoSaloon from '../../Img/Delivery/logoSaloon.png'
import {
    Map,
    ObjectManager,
    Placemark,
    SearchControl,
    useYMaps,
    withYMaps,
    YMaps,
    ZoomControl
} from "@pbe/react-yandex-maps";
import imgMarker from '../../Img/Delivery/markerSmall.png'
import {ListBoxItem} from "@pbe/react-yandex-maps";
import {ListBox} from "@pbe/react-yandex-maps";
import {YMapsModules} from "@pbe/react-yandex-maps/typings/util/typing";
import {debounceTime, Subject,from} from "rxjs";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import WaitLoader from "../../WaitLoader/WaitLoader";
import {useDispatch, useSelector} from "react-redux";
import {ReduxStateInt, setOrderData} from "../../Reducer/GlobalReducer";
import InputItem from "../../FormTemplate/InputItem/InputItem";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";


interface DeliveryOptionInt
{
    yaMapApiKey:string
    yaMapSuggestKey:string
}




interface AddInfoItemInt {
    name:string
    isCorrect: boolean
    val:string
}

interface UploadAddInfoInt
{
    orderId:string
    sessionId:string
    infoList:AddInfoItemInt[]
}


interface PointInfoInt
{
    name: string
    val:string
    mark?:boolean
}


interface DeliveryDataItemInt
{
    deliveryId:number
    price: number
    postalCode:string
    id?:number
}

interface YMFeatureObjectInt
{
    type: string
    id:number
    geometry: {
        type:string
        coordinates: number[]
    }
    properties: {
        hintContent: string
        balloonContent: string
        city: string
        isCluster: boolean
        clusterCount: number
        postCode:number
        [key:string]: any

    }
}

interface DeliveryPointInfo
{
    show: boolean
    city: string
    address: string
    postalCode: string
    typeId:number
    price?: number
    duration?: number

}

interface MapStateInt
{
    zoom:number
    topLeft: number[]
    bottomRight:number[]
}

interface DeliveryItemPropsInt {
    cbExecute: (data?:any)=>void
    contWidth?:number
}

interface CustomerItemInt
{
    name:string,
    logo: string,
    isSelected: boolean,
    customerId: number,
    active : boolean,
    minPrice:number,
    mapTop?:number,
    mapBottom?:number,
    mapLeft?:number,
    mapRight?:number
    addInfo:string
    desc?:string

}


export default function DeliveryItem({cbExecute,contWidth}:DeliveryItemPropsInt) {

    const rxObserve = useSelector((state: ReduxStateInt) => {
        return state.rxObserve
    })
    const errorLineRef = useRef<ErrorLineItemRef>(null)

    const orderData = useSelector((state: ReduxStateInt) => {
        return state.orderData
    })
    const dispatch = useDispatch()

    const dataCardItem = useSelector((state: ReduxStateInt) => {
        return state.slider?.dataCardItem
    })


    const [addInfoItem,setAddInfoItem] = useState<AddInfoItemInt[]>([])


    //Опции доставки ключи и тп
    const deliveryOptionData = useRef()
    const [ldrDeliveryOption,rsDeliveryOption,exDeliveryOption] = useApiQuery("/sell/sim/delivery/option","get",deliveryOptionData);
    const [deliveryOption, setDeliveryOption] = useState<DeliveryOptionInt>()


    const dataDeliveryNeed = useRef<{
        orderId:string
        sessionId:string

    }>()
    const [ldrDeliveryNeed,rsDeliveryNeed,exDeliveryNeed] = useApiQuery("/sell/sim/order/delivery/need","post",dataDeliveryNeed);


    const [delRowLen,setDelRowLen] = useState(Number(getComputedStyle(document.documentElement).getPropertyValue('--delivery-row-len')))

    const containerRef = useRef<HTMLDivElement>(null)


    //Список доставщиков по тарифу
    const customerListData = useRef({
        tarifId: "-1",
        orderId: "-1"
    })
    const [ldrCustomerList,rsCustomerList,exCustomerList] = useApiQuery("/sell/sim/tarif/delivery/list","post",customerListData);
    const [customerList,setCustomerList] = useState<CustomerItemInt[]>([])

    //Массив строк с сервера про точку
    const [pointInfo, setPointInfo] = useState<PointInfoInt[]>([])


    const [deliveryPointItem , setDeliveryPointItem] = useState<DeliveryDataItemInt>()

    //Выбранный customerId
    const [customerId, setCustomerId] = useState(0)//0 СДЭК 1 Почта
    const [useSearch, setUseSearch] = useState(true)


    const [blurMap, setBlurMap] = useState(false)

    //Загрузка списка точек по координатам и зуму
    const pointListData = useRef({
        deliveryType:customerId,
        zoom : 12,
        topLeft:[82.75,54.8],
        bottomRight:[83.16,55.199]
    })
    const [ldrPointList,rsPointList,exPointList] = useApiQuery("/geo/point/load","post",pointListData);
    const [pointList,setPointList] = useState<YMFeatureObjectInt[]>([])
    const [clusterList,setClusterList] = useState<YMFeatureObjectInt[]>([])


    const [scrollToUp, setScrollToUp] = useState(false)


    // Информация о точке и там прописывается в заказе
    const pointInfoData = useRef({
        deliveryId:0,
        pointId: "",
        orderId:"",
        sessionId:""
    })
    const [ldrPointInfo,rsPointInfo,exPointInfo] = useApiQuery("/geo/point/info","post",pointInfoData);


    const [deliveryNeedCheck, setDeliveryNeedCheck] = useState(true)


    //Загрузка доп инфы по точке, телефон почта и тп
    const uploadAddInfoData = useRef<UploadAddInfoInt>()
    const [ldrUploadAddInfo,rsUploadAddInfo,exUploadAddInfo] = useApiQuery("/sell/sim/order/delivery/info","post",uploadAddInfoData);





    const mapWidth =  window.innerWidth-60
    const [mapSize, setMapSize]= useState([mapWidth > 1000 ? 1000: mapWidth,window.innerWidth < 610 ? window.innerWidth-20 : 600])
    const [bound, setBound] = useState([[54.80, 82.75],[55.199,83.16]])

    const refPointManager = useRef<any>(undefined)
    const refClusterManager = useRef<any>(undefined)
    const refMap = useRef<any>()


    const [vl , setVl] = useState("")
    const [debounceVl,setDebounceVl] = useState("")

    const yApi = useRef<any>(null)

    const rxSearch = useRef( new Subject<string>())
    const rxMove = useRef( new Subject<MapStateInt>())


    const [mapState, setMapState] = useState<MapStateInt>({
        zoom: 10,
        bottomRight:[83.16,55.199],
        topLeft:[ 82.75,54.8]
    })




    //Выбранная точка в формате YMFeatureObjectInt при клике по значку данные из yandexObj
    const [selectedPoint, setSelectedPoint] = useState<YMFeatureObjectInt>()

    //Инфа о точке  с сервера для вывода информации в окне о точке
    const [selectedPointInfo, setSelectedPointInfo] = useState<any>({})


    const [suggestAddress, setSuggestAddress] = useState<any[]>([])


//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    useEffect(()=>{
        if(mapSize[0] > 100){
            rxObserve.next({
                message: "orderBlock-width",
                data: `${mapSize[0] + 50}px`
            })
        }

    },[mapSize])
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    useEffect(()=>{
        console.log("DeliveryNeedCheck state", deliveryNeedCheck)

    },[deliveryNeedCheck])
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    useEffect(()=>{
            handleDeliveryNone()

    },[orderData?.orderId])
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    useEffect(()=>{
        console.log(`change customer ${customerId}`)
        //setAddInfoItem([])

        if(customerId === 4) setUseSearch(false) //Убираем поиск если салон
        else setUseSearch(true)

        const customer = customerList?.filter((item)=>item?.customerId === customerId)
        if(! customer?.length) return
        if(! customer[0]?.addInfo) return
        const addInfoList = customer[0]?.addInfo?.split(';')?.slice(0,-1)
        setAddInfoItem(
            addInfoList?.map((item)=>{
                let val = ""
                if(item?.match(/phone/ui) && orderData?.regMode ===10 ){
                    val = orderData?.mnpData?.ctn ? orderData?.mnpData?.ctn : ""

                }
                if(item?.match(/icc/ui) ){
                    val = "8970"
                }
                return{
                    name: item,
                    isCorrect: false,
                    val: val
                }
            })
        )




    },[customerId,customerList])

    useEffect(()=>{
        console.log("ef aaddInfoItem ", addInfoItem)
    },[addInfoItem])

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    useEffect(()=>{
        if(containerRef.current && scrollToUp)containerRef.current.scrollIntoView()
    },[scrollToUp])

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    useEffect(()=>{
        loadDeliveryOption()
    },[deliveryOptionData])
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    useEffect(()=>{
        console.log("change orderData", orderData)
        if(orderData?.orderId && orderData?.tarifData?.tarifId)loadCustomerList()
    },[orderData.orderId])

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    useEffect(()=>{
        pointListData.current = {
            deliveryType: customerId,
            zoom: mapState.zoom,
            topLeft: mapState.topLeft,
            bottomRight: mapState.bottomRight
        }
        loadPointList()
        //setSelectedPoint(undefined)
    },[mapState])

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    useEffect(()=>{
        loadPointList()
    },[pointListData,customerId])

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    useEffect(()=>{
        if(errorLineRef?.current && selectedPoint)errorLineRef.current.show("Загружаю информацию по точке",false,1000)
        loadPointInfo()

    },[selectedPoint])

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    useEffect(()=> {
        rxSearch.current.pipe(debounceTime(700)).subscribe((e) => {
            setDebounceVl(e ? e?.toString() : "")
        })
    },[rxSearch]);
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    useEffect(()=> {
        rxMove.current.pipe(debounceTime(800)).subscribe((e:MapStateInt) => {
            //console.log("map set :",e)
            // setBound([e.topLeft.reverse(),e.bottomRight.reverse()])
            if(ldrPointList) return;
            //console.log("set by move",e)
            setMapState(e)
        })
    },[rxMove]);
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    useEffect(()=>{
        //if(mapRef.current)mapRef.current.setZoom(10)
    },[pointList])
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    useEffect(()=>{
        if (debounceVl.length > 3 && yApi.current) {

            yApi.current?.geocode(debounceVl,{json:true}).then((e:any)=>{
                try {
                    //  console.log("found",e)
                    const list = e?.GeoObjectCollection?.featureMember
                    if(list === undefined || !Array.isArray(list)) return
                    setSuggestAddress(list)
                    const addList = list.map((item: any, idx)=>{
                        //console.log(item)
                        if(idx === -1)
                        {
                            const lb = item?.GeoObject?.boundedBy?.Envelope?.lowerCorner?.split(' ')
                            const tr = item?.GeoObject?.boundedBy?.Envelope?.upperCorner?.split(' ')
                            setBound([[Number(lb[1]),Number(lb[0])],  [Number(tr[1]), Number(tr[0])] ])
                            console.log("found ",[Number(lb[0]),Number(lb[1])],[Number(tr[0]), Number(tr[1])])
                            setMapState({...mapState,topLeft:[Number(lb[0]),Number(lb[1])],bottomRight:[Number(tr[0]), Number(tr[1])]})
                            setSelectedPoint(undefined)

                        }
                        return item?.GeoObject?.metaDataProperty?.GeocoderMetaData?.text
                    })
                    //console.log("list", addList)
                } catch (e) {console.log(e)}
            })
        }
    },[debounceVl])


    const chunkArray = (arr:any[],chunkSize=delRowLen) =>{
        const result=[];
        for(let i=0;i<arr.length;i+=chunkSize) {
            result.push(arr.slice(i,i+chunkSize));
        }
        return result;
    }

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    const loadDeliveryOption = () =>{
        exDeliveryOption().then((e)=>{
            if(e?.success)
            {
                const payload = e?.payload
                setDeliveryOption({
                    yaMapApiKey: payload?.yaMapApiKey,
                    yaMapSuggestKey: payload?.yaMapSuggestKey,
                })
                return

            }
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки опций",true,5000)
        }).catch((e)=>{
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки опций",true,5000)
        })
    }

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    const loadCustomerList = () =>{
        if(! orderData?.orderId || !orderData?.tarifData?.tarifId) return
        customerListData.current = {
            orderId : orderData?.orderId,
            tarifId: orderData?.tarifData?.tarifId,
        }
        exCustomerList().then((e)=>{
            if(e.success  && Array.isArray(e?.payload))
            {
                //console.log(e?.payload)
                const payload = e?.payload
                const a:CustomerItemInt[] = payload.map((item,idx)=>{
                    const itm:CustomerItemInt = {
                        customerId: item?.customerId,
                        active: true,
                        minPrice: item?.minPrice ? item?.minPrice : 0,
                        isSelected: idx === 0 ? true:false,
                        name: item?.name,
                        logo:"",
                        mapBottom: item?.mapBottom,
                        mapLeft: item?.mapLeft,
                        mapRight: item?.mapRight,
                        mapTop: item?.mapTop,
                        addInfo: item?.addInfo,
                        desc: item?.desc,
                    }
                    switch (item?.customerId)
                    {
                        case 0: itm.logo = logoCdek
                            break
                        case 1: itm.logo = logoPost
                            break
                        case 2: itm.logo = logoSelf
                            break
                        case 3: itm.logo = logoEsim
                            break
                        case 4: itm.logo = logoSaloon
                            break
                        case 5: itm.logo = logoNo
                            break
                        case 6: itm.logo = logoSim

                            break
                    }
                    return itm

                })
                setCustomerList(a)
                setCustomerId(0)
                setScrollToUp(true)
                return

            }
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки списка партнеров",true,5000)

        }).catch((e)=>{
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки списка партнеров",true,5000)

        })
    }
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    const handlePointClick = (e:any) =>{
        const  objectId = e.get('objectId')
        console.log("clicked objectId->",objectId)
        console.log("selectedPoint->",selectedPoint)
        console.log("selectedPointInfo->",selectedPointInfo)
        if(objectId && selectedPoint && objectId !== selectedPoint?.id)
        {
            //Если не равно текущей то сбрасываем
            setSelectedPointInfo(undefined)//Сбрасываем старую инфу

        }
        const filter = pointList.filter((item)=>{
            if(item.id === objectId) return true
            return false
        })
        console.log("filter point len",filter.length)
        if (filter.length)  setSelectedPoint(filter[0])
        else setSelectedPoint(undefined)
    }
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    const handleClusterClick = (e:any) =>{
        setSelectedPoint(undefined)
        try {
            const  objectId = e?.get('objectId')
            const obj = refClusterManager.current?.objects?.getById(objectId)
            if(obj === null) return;
            const coord = obj?.geometry?.coordinates

            let zoom = refMap.current.getZoom()
            zoom =  (zoom+1)>21 ? 21: zoom+1
            refMap.current.setZoom(zoom)
            refMap.current.setCenter(coord)


        } catch (e) {console.log(e)}


    }
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    const deliveryLogo = ()=>{
        if(ldrPointInfo)return null
        let logo = undefined
        if(customerId === 0)logo = logoCdek
        if(customerId === 1)logo = logoPost
        if(customerId === 2)logo = logoSelf
        if(customerId === 3)logo = logoEsim
        if(customerId === 4)logo = logoSaloon
        if(logo === undefined) return null
        return (
            <div className={styles.logoCont}>
                <img src={logo}/>
            </div>
        )


    }


//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    const loadPointList = () =>{
        //if(ref.current)ref.current.removeAll()
        if(errorLineRef?.current)errorLineRef.current.show("Загружаю список точек",false,2000)
        exPointList().then((e)=>{
            if(e.success)
            {
                let bound:any
                // console.log(e?.payload)
                const apl:YMFeatureObjectInt[] = e?.payload?.map((item:any)=>{
                    const itm:YMFeatureObjectInt = {
                        id: item?.id,
                        type:"Feature",
                        geometry: {
                            type: "Point",
//                            coordinates: [item?.longitude, item?.latitude]
                            coordinates: item?.geometry?.coordinates?.reverse()
                        },
                        properties: {
                            hintContent: item?.properties?.postCode ? item.properties.postCode : "--",
                            balloonContent: "",
                            city: item?.properties?.city ? item.properties.city : "---",
                            isCluster: item?.properties?.isCluster ? true : false,
                            clusterCount: item?.properties?.clusterCount !== undefined ? item?.properties?.clusterCount : 0,
                            postCode: item?.properties?.postCode,
                            typeId: item?.properties?.typeId
                        }
                    }

                    //if(ref.current)ref.current.add(itm)
                    return itm
                })

                const point = apl.filter((item)=>{
                    if(item.properties?.isCluster) return false
                    return true
                })
                setPointList(point)

                const cluster = apl.filter((item)=>{
                    if(item.properties?.isCluster) return true
                    return false
                })

                const formattedCluster = cluster.map((item)=>{
                    const count = item?.properties?.clusterCount !== undefined ? item?.properties?.clusterCount : 0
                    return {...item, /*options: {iconColor: "#ff0000", preset: "islands#redCircleIcon"} ,*/ properties: {...item.properties, iconContent: count,hintContent: `${count} точек`} }
                })


                setClusterList(formattedCluster)
                return


            }
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки списка точек",true,5000)

        }).catch((e)=>{
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки списка точек",true,5000)

        })
    }

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    const  handleSearch = (e:string)=>{
        rxSearch.current.next(e)
        setVl(e)
    }

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    const YaApiItem = ({ymaps}:any)=> {
        if(ymaps )
        {
            yApi.current = ymaps
        }
        return null
    }

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    const buildSuggest = () =>{
        if(! suggestAddress.length) return null
        return (
            <div className={styles.inSugg}>
                {suggestAddress.map((item,idx)=>{
                    //console.log("sugg",item)
                    return(
                        <div key={idx}  onClick={()=>handleSuggestAddress(item)} className={styles.suggitem}>{item?.GeoObject?.metaDataProperty?.GeocoderMetaData?.text}</div>
                    )
                })}
            </div>
        )

    }

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    const handleSuggestAddress = (item:any) =>{
        //console.log("select",item)
        const lb = item?.GeoObject?.boundedBy?.Envelope?.lowerCorner?.split(' ')
        const tr = item?.GeoObject?.boundedBy?.Envelope?.upperCorner?.split(' ')
        setBound([[Number(lb[1]),Number(lb[0])],  [Number(tr[1]), Number(tr[0])] ])
        //console.log("found ",[Number(lb[0]),Number(lb[1])],[Number(tr[0]), Number(tr[1])])
        setMapState({...mapState,topLeft:[Number(lb[0]),Number(lb[1])],bottomRight:[Number(tr[0]), Number(tr[1])]})
        setSelectedPoint(undefined)
        setSuggestAddress([])

    }
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    const searchItem = () =>{
        if(!useSearch) return null
        return(
            <div className={styles.inCont}>
                <div className={styles.inpBlk}>
                    <input className="form-control"
                           type={"text"}
                           value={vl}
                           disabled={!useSearch}
                           onChange={(e)=>handleSearch(e.target.value)}
                           placeholder={"Поиск [город, улица]"}

                    ></input>
                    <div className={styles.suggClear} onClick={()=>{
                        setVl("")
                        setSuggestAddress([])
                    }}>
                        <i className='bx bxs-x-square'></i>
                    </div>
                    {buildSuggest()}
                </div>
                <div className={styles.ldrCont}>
                    <WaitLoader loading={ldrPointList} api={rsPointList} onlyLoading={true}>

                    </WaitLoader>
                </div>
            </div>
        )
    }




//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!


    const ButtonWithYMap = useMemo(()=>{
        return withYMaps(YaApiItem, true,['route','geocode'])
    },[Map])

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    const buildSelectedPoint = () =>{
        if(! selectedPoint) return (
            <div className={styles.ptCont}>
                <div className={styles.ptTitle}>Выберите пункт</div>
                <div className={styles.ptImCont}>
                    <img src={yaMarker}></img>
                </div>
                <div className={styles.ptTitle}>на карте</div>
            </div>
        )
        switch (customerId)
        {
            case 4:
                return(
                    <div>
                        {`Уточняйте список салонов в Вашем населенном пункте`}
                    </div>
                )
                break
            case 3:
                return(
                    <div>
                        {`Qr - код придет в личный кабинет`}
                    </div>
                )
                break
            case 2:
                return(
                    <div>
                        {`Самовывоз из офиса компании`}
                    </div>
                )
                break
            case 5:
                return(
                    <div>
                        {`Доставка не требуется`}
                    </div>
                )
                break
            case 6:
                return(
                    <div>
                        {`На Ваш пластик, полученный ранее `}
                    </div>
                )
                break
            case 0:
                return(
                    <div>
                        {`Выбранный ПВЗ : [ ${selectedPoint.properties?.postCode} ] ${selectedPoint.properties.city}`}
                    </div>
                )
                break
            case 1:
                let warning = undefined
                //console.log(selectedPoint)
                switch (selectedPoint.properties?.typeId)
                {
                    case 33:
                        warning= <span>[ постомат ]</span>
                        break
                    case 46:
                        warning= <span>[ партнеры ]</span>
                        break
                    case 18:
                        warning= <span>[ передвижной пункт ]</span>
                        break
                    default:

                }
                return(
                    <div className={styles.spTitle}>
                        {`Выбранный ПВЗ : [ ${selectedPoint.properties?.postCode} ] ${selectedPoint.properties.city} `}{warning}
                    </div>
                )
                break
            default:
                return (
                    <></>
                )
        }



        return null



    }//

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    const handleMapEvent = (e:any) =>{
        //console.log("fired",e.originalEvent.target.getZoom(),e.originalEvent.target.getBounds())
        try {
            const bound = e.originalEvent.target.getBounds()
            //console.log("bound :", bound)
            if(rxMove)rxMove.current.next({
                zoom: e.originalEvent.target.getZoom(),
                bottomRight: bound[1].reverse(),
                topLeft: bound[0].reverse()
            })

        } catch (e) {

        }
    }

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    const handleSelectCustomer = (id :number)=>{

        const newCustomerList = customerList.map((item,idx)=>{
            item.isSelected = false
            if(idx === id){
                item.isSelected = true
                setCustomerId(item.customerId)
                if(pointListData.current)pointListData.current.deliveryType = item.customerId
                if(item?.mapTop && item?.mapRight && item?.mapBottom && item?.mapLeft)
                {
                    //setBound([[55.04349972596763,82.89584830029037],[55.05089192084076,82.9173059724095]])
                    setBound([[item.mapBottom,item.mapLeft],[item.mapTop, item.mapRight]])
                }

                switch (item.customerId)
                {
                    case 4:
                    case 2:
                    case 5:
                    case 6:
                        setBlurMap(true)
                        break
                    default: setBlurMap(false)
                }

                switch (item.customerId)
                {
                    case 3:
                    case 2:
                    case 4:
                    case 5:
                    case 6:
                        setSelectedPoint({
                            type:"Feature",
                            id:668,
                            geometry: {
                                type: "Point",
                                coordinates: []
                            },
                            properties: {
                                postCode:0,
                                city: "",
                                clusterCount:0,
                                isCluster: false,
                                hintContent: "",
                                balloonContent:""
                            }
                        })
                        break
                    default:
                        setSelectedPoint(undefined)
                }

            }
            return item
        })
        setCustomerList(newCustomerList)
    }
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    const buildDeliveryList = ()=>{
        const chunk = chunkArray(customerList)
        return chunk.map((item,idx)=>{
            return(
                <div key={idx} className={styles.delRow}>
                    {
                        item.map((itm,i)=>{
                            return(
                                <div key={i} className={styles.delCont}
                                     onClick={(e)=>handleSelectCustomer(idx * delRowLen + i)}
                                >
                                    <div className={[styles.delMarker, itm?.isSelected ? styles.marSelected : ""].join(' ')}></div>
                                    <img src={itm?.logo}/>
                                    <div className={styles.delText}>{itm?.name}</div>
                                </div>
                            )
                        })
                    }
                </div>
            )
        })

    }


//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    //Если оператор такой же ставим доставку none rод 5
    const handleDeliveryNone = ()=> {
        const orderId = orderData?.orderId ? orderData?.orderId : "-1"
        const sessionId = orderData?.sessionId ? orderData?.sessionId : "-1"

        dataDeliveryNeed.current = {
            orderId: orderId,
            sessionId: sessionId
        }
        exDeliveryNeed().then((e)=>{
            if(e?.success)
            {
                const need = e?.payload?.need !== undefined ? e?.payload?.need : true
                if(need) {
                    setDeliveryNeedCheck(false)
                    return
                }
                pointInfoData.current = {
                    deliveryId: 5,
                    orderId: orderData?.orderId ? orderData?.orderId : "-1",
                    pointId: "empty",
                    sessionId: orderData?.sessionId ? orderData?.sessionId : "-1"
                }
                exPointInfo().then((e) => {
                    if(e?.success)
                    {
                        dispatch(setOrderData({...orderData,deliveryData: e?.payload?.point}))
                        if(cbExecute)cbExecute()
                    }
                    setDeliveryNeedCheck(false)
                }).catch(()=>{
                    setDeliveryNeedCheck(false)
                })
            }
        }).catch(()=>{
            setDeliveryNeedCheck(false)
        })


    }
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    const loadPointInfo = () =>{
        if(!selectedPoint) return;
        console.log("load point info about point", selectedPoint)
        pointInfoData.current.deliveryId =  customerId
        pointInfoData.current.orderId =  orderData?.orderId ? orderData?.orderId : "-1"
        pointInfoData.current.sessionId =  orderData?.sessionId ? orderData?.sessionId : "-1"
        switch (customerId)
        {
            case 0:
                pointInfoData.current.pointId = selectedPoint?.properties?.postCode !==undefined ? selectedPoint?.properties?.postCode.toString() : ""
                break
            case 1:
                pointInfoData.current.pointId = selectedPoint?.properties?.postCode !==undefined ? selectedPoint?.properties?.postCode.toString() : ""
                break
            case 2:
                pointInfoData.current.pointId = selectedPoint?.properties?.postCode !==undefined ? selectedPoint?.properties?.postCode.toString() : ""
                break
            case 3:
                pointInfoData.current.pointId = selectedPoint?.properties?.postCode !==undefined ? selectedPoint?.properties?.postCode.toString() : ""
                break
            case 4:
                pointInfoData.current.pointId = selectedPoint?.properties?.postCode !==undefined ? selectedPoint?.properties?.postCode.toString() : ""
                break
            default: pointInfoData.current.pointId = selectedPoint?.properties?.postCode !==undefined ? selectedPoint?.properties?.postCode.toString() : ""
        }
        console.log("load point info",pointInfoData.current)
        if(pointInfoData.current.pointId.length < 1) return

        //console.log("load point info",pointInfoData.current)
        exPointInfo().then((e)=>{
            if(e.success)
            {
                if(Array.isArray(e?.payload?.itemList))
                {
                    console.log("point info",e?.payload)
                    setPointInfo(e?.payload?.itemList)
                }
                if(e?.payload?.point)
                {
                    setSelectedPointInfo(e?.payload?.point)
                    dispatch(setOrderData({...orderData,deliveryData: e?.payload?.point}))
                }
                return
            }
            console.log("reset")
//            setSelectedPoint(undefined)
            setSelectedPointInfo(undefined)//Сбрасываем старую инфу
            setTimeout(()=>setSelectedPoint(undefined),3000)
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки информации по точке",true,2000)


        }).catch((e)=>{
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки информации по точке",true,2000)
            setSelectedPointInfo(undefined)
        })


    }

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    const handleSelectPoint = () =>{
        //dispatch(setOrderData({...orderData,deliveryData: deliveryPointItem}))
        uploadAddInfoData.current = {
            orderId: orderData?.orderId ? orderData?.orderId : "-1",
            sessionId: orderData?.sessionId ? orderData?.sessionId : "-1",
            infoList: addInfoItem
        }
        exUploadAddInfo().then((e)=>{
            console.log(e)
            if(cbExecute)cbExecute()

        })



    }
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    const buildDeliveryItemList = () =>{
        return pointInfo.map((item,idx)=>{
            return(
                <div className={styles.delListRow} key={idx}>
                    <div className={styles.delListName}>{item?.name + " :"}</div>
                    <div className={[styles.delListVal, item?.mark ? styles.delListValMark : ""].join(' ')}>{item?.val}</div>
                </div>
            )
        })
    }


    const isValidAddInfo = () =>{
        if(!addInfoItem?.length) return true
        return addInfoItem?.reduce((acc, item)=>{
            if(! item?.isCorrect) acc = false
            return acc
        },true)
    }

    const setCorrectValueAddInfo = (name:string, val:boolean) => {
        setAddInfoItem( addInfoItem?.map((item)=>{
            if(item?.name === name)item.isCorrect = val
            return item
        }) )
    }


    const readValueAddInfo = (name:string) =>{
        const vl = addInfoItem?.filter((item)=>item?.name === name)
       // console.log("readValueAddInfo",vl[0]?.val)
        if(! vl?.length) return ""
        return  vl[0]?.val
    }
    const normCtn = (e:string) => {
        const t = e.toString()
        const mh = t.match(/[0-9]{10}$/ui)
        if(mh) return "+7" + mh[0]
        return t

    }



    const buildAddInfoItem = (item:AddInfoItemInt,idx:number) =>{
        if(item?.name?.match(/phone/ui))
        {
            return(
                <div className={styles.addInfo} key={idx}>
                    <InputItem
                        title={"Конт.телефон"}
                        val={readValueAddInfo("phone")}
                        placeHolder={"XXXXXXXXXX"}
                        info={"Номер телефона для связи"}
                        mode={"ei"}
                        hideEditIcon={true}
                        type={"numeric"}
                        regExp={/^((\+7)|(8)|(^))9[0-9]{9}$/ui}
                        //onBlur={(e)=> setValueAddInfo("phone",e?.toString())}
                        onChange={(e)=>{
                            //console.log(`change to ${e}`,addInfoItem, e=== null, e===undefined)
                            setAddInfoItem( addInfoItem?.map((item)=>{
                                if(item?.name === "phone")
                                {
                                    const vl = e?.toString()?.replace(/[^+0-9]/uig,'')
                                    item.val = vl
                                    item.isCorrect = !!vl.match(/^((\+7)|(8)|(^))9[0-9]{9}$/ui)
                                    if(item?.isCorrect) item.val = normCtn(vl)
                                }
                                return item
                            }) )
                        }}
                    />
                </div>
                )
        }
        if(item?.name?.match(/mail/ui))
        {
            return(
                <div className={styles.addInfo} key={idx}>
                    <InputItem
                        title={"e-Mail"}
                        val={readValueAddInfo("mail")}
                        placeHolder={"XXXXXXXXXX"}
                        hideEditIcon={true}
                        info={"Электронная почта"}
                        mode={"ei"}
                        regExp={/^((\+7)|(8)|(^))9[0-9]{9}$/ui}
                        //onBlur={(e)=> setValueAddInfo("phone",e?.toString())}
                        onChange={(e)=>{
                            setAddInfoItem( addInfoItem?.map((item)=>{
                                if(item?.name === "mail")
                                {
                                    const vl = e?.toString()
                                    item.val = vl
                                    item.isCorrect = !!vl.match(/^((\+7)|(8)|(^))9[0-9]{9}$/ui)
                                    if(item?.isCorrect) item.val = normCtn(vl)
                                }
                                return item
                            }) )
                        }}
                    />
                </div>
            )
        }
        if(item?.name?.match(/icc/ui))
        {
            return(
                <div className={styles.addInfo} key={idx}>
                    <InputItem
                        title={"Штрих код"}
                        val={readValueAddInfo("icc")}
                        placeHolder={"XXXXXXXXXX"}
                        hideEditIcon={true}
                        info={"Штрих код пластика"}
                        mode={"ei"}
                        titleShift={0}
                        regExp={/^[0-9]{17,22}$/ui}
                        //onBlur={(e)=> setValueAddInfo("phone",e?.toString())}
                        onChange={(e)=>{
                            setAddInfoItem( addInfoItem?.map((item)=>{
                                if(item?.name === "icc")
                                {
                                    const vl = e?.toString()?.replace(/[^0-9]/uig,'')
                                    item.val = vl
                                    item.isCorrect = !!vl.match(/^[0-9]{17,22}$/ui)
                                    if(item?.isCorrect) item.val = (vl)
                                }
                                return item
                            }) )
                        }}
                    />
                    <div className={styles.smCont}>
                        <img src={simFull} alt={"Сим карта"}/>

                    </div>
                </div>
            )
        }

        return null
    }
  //  onIncorrect={(e)=>setCorrectValueAddInfo("phone", false)}

    const buildAddInfo = () =>{

        if(! addInfoItem.length) return null
        return(
            <div>
                <div className={[styles.adInfoTitle, styles.blink].join(' ')}>Необходимы дополнительные данные</div>
                <div>
                        {addInfoItem?.map((item,idx)=>buildAddInfoItem(item,idx))}
                </div>
            </div>
        )
    }

    const deliveryPoint = ()=>{
       // console.log("a",selectedPoint)
       // console.log("b",selectedPointInfo)
        console.log("selectedPointInfo",selectedPointInfo)
        console.log("selectedPoint",selectedPoint)
        if(! selectedPoint) return null
        if(! selectedPointInfo && (!ldrPointInfo )) return null
        const canDelivery =  selectedPointInfo?.canDelivery !== undefined ? selectedPointInfo?.canDelivery : true
        let showCancel = true
        switch (customerId)
        {
            case 2:
            case 4:
            case 5:
            case 6:
                showCancel = false
                break

        }

        return(
            <div className={styles.infCont}>
            <WaitLoader loading={ldrPointInfo || ldrUploadAddInfo } api={rsPointInfo} onlyLoading={true}>

                { canDelivery &&
                    <>
                        <div className={styles.delListCont}>
                            {buildDeliveryItemList()}
                        </div>
                        <div className={styles.delListCont}>
                            {buildAddInfo()}
                        </div>
                        <div className={styles.btnLineSmall}>

                            <button type="button" className="btn btn-face"
                                //disabled={!(stage === 0 || stage === 2)}
                                    disabled={! isValidAddInfo()}
                                    onClick={()=>handleSelectPoint()}
                            >Выбрать</button>
                            {showCancel &&
                                <button type="button" className="btn btn-face"
                                    //disabled={!(stage === 0 || stage === 2)}
                                        onClick={()=>setSelectedPoint(undefined)}
                                >Отмена</button>
                            }

                        </div>
                    </>
                }

                {!canDelivery &&
                    <div className={styles.errDel}>Регион доставки не совпадает с регионом действия тарифа, Доставка не может быть осуществлена. Выберите корректный адрес доставки или смените регион</div>

                }


            </WaitLoader>
            </div>
        )
    }
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    const buildPointTitle = () =>{
        return(
            <div className={styles.ptCont}>
                <div>Выберите пункт</div>
                <div className={styles.ptImCont}>
                    <img src={yaMarker}></img>
                </div>
                <div>на карте</div>
            </div>
        )
    }

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    const buildBlurMap =  ()=>{
        if(!blurMap) return null
        let text
        switch (customerId)
        {
            case 6: text = `Укажите код под штрих кодом на пластике, без пробелов`
                break
            case 4: text = `Салон выбирать не нужно - получить можно в любом салоне ${orderData?.tarifData?.operName ? orderData?.tarifData?.operName : ""}`
                break
            default: text = ""
        }

        return (
            <div className={styles.blurMap} style={{height:`${mapSize[1]}px`,width:`${mapSize[0]}px`}}>
                <div className={styles.blurText}>{text}</div>
            </div>
        )
    }


//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    const buildCustomerInfo = ()=>{
        console.log("customerList",customerList)
        if(! customerList.length) return null
        const customer = customerList?.filter((item)=>item?.customerId === customerId)
        if(!customer?.length) return null
        let desc = customer[0]?.desc
        if(! desc) return null
        const operName = dataCardItem?.operOne?.name ? dataCardItem?.operOne?.name : ""

        desc = desc?.replaceAll(/\{\{operId\}\}/uig,operName)


        return (
            <div className={styles.cusDescCont}>
                {desc}
            </div>
        )

    }
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    if(ldrDeliveryNeed || deliveryNeedCheck) return null
    return (
        <div className={styles.mCont} >
                <div className={styles.titleCont}>
                    <div className={styles.titleImgCont}>
                    </div>
                    <div ref={containerRef} className={styles.title}>Выберите оператора доставки и пункт выдачи</div>

                </div>

                <WaitLoader loading={ldrCustomerList} api={rsCustomerList} onlyLoading={true}>
                    <div className={styles.selCont}>
                        {buildDeliveryList()}
                    </div>

                </WaitLoader>

                {buildCustomerInfo()}
                <div className={styles.errCont}>
                    <ErrorLineItem ref={errorLineRef}></ErrorLineItem>
                </div>
                <WaitLoader loading={ldrDeliveryOption} api={rsDeliveryOption} onlyLoading={true}>
                    <div className={styles.mainCont}>
                        <div style={{height:mapSize[1]+50+"px"}}>
                            <YMaps query={{apikey:deliveryOption?.yaMapApiKey,lang:"ru_RU",suggest_apikey: deliveryOption?.yaMapSuggestKey}}   >
                                <Map
                                    state={{
                                        bounds:bound,
                                    }}

                                    instanceRef={(e)=>{
                                        try {
                                            if(refMap.current )
                                            {
                                                refMap.current?.events.remove('actionend',handleMapEvent)
                                            }
                                            if(e === null) return
                                            refMap.current = e
                                            e.events.remove('actionend',handleMapEvent)
                                            e.events.add('actionend',handleMapEvent)

                                        } catch (e) { console.log(e)}
                                    }}
                                    height={mapSize[1]}
                                    width={mapSize[0]}
                                    options={{suppressMapOpenBlock: true,suppressObsoleteBrowserNotifier:true,yandexMapDisablePoiInteractivity: true,copyrightLogoVisible:false,copyrightUaVisible: false,}}
                                    //instanceRef={ref}
                                    onClick={(e:any)=>{
                                        //console.log(e.get("coords"))
                                        console.log("setSelectedPoint -> undefined")
                                        setSelectedPoint(undefined)
                                    }}



                                >
                                    <div className={styles.pvzTitle}>
                                        {buildSelectedPoint()}
                                    </div>
                                    {buildBlurMap()}

                                    <ZoomControl  options={{}} />
                                    <ObjectManager
                                        options={{
                                            clusterize: false,
                                            gridSize: 0,
                                        }}
                                        instanceRef = {(e:any)=>{
                                            try {
                                                if(refPointManager.current )
                                                {
                                                    refPointManager.current?.events.remove('click',handlePointClick)
                                                }
                                                if(e === null) return
                                                refPointManager.current = e
                                                e.events.remove('click',handlePointClick)
                                                e.events.add('click',handlePointClick)
                                            } catch (e) {console.log(e)}
                                        }}
                                        objects={{
                                            openBalloonOnClick: false,
                                            preset: "islands#blackDotIcon",
                                        }}
                                        clusters={{
                                            preset: "islands#greenClusterIcons",
                                        }}
                                        features = {{type: "FeatureCollection", features: pointList}}
                                        modules={[
                                            "objectManager.addon.objectsBalloon",
                                            "objectManager.addon.objectsHint",
                                        ]}
                                    />


                                    <ObjectManager
                                        options={{
                                            clusterize: false,
                                            gridSize: 0,
                                        }}
                                        instanceRef = {(e:any)=>{
                                            try {
                                                if(refClusterManager.current )
                                                {
                                                    refClusterManager.current?.events.remove('click',handleClusterClick)
                                                }
                                                if(e === null) return
                                                refClusterManager.current = e
                                                e.events.remove('click',handleClusterClick)
                                                e.events.add('click',handleClusterClick)
                                            } catch (e) {console.log(e)}
                                        }}
                                        objects={{
                                            openBalloonOnClick: false,
                                            preset: "islands#redCircleIcon",
                                        }}
                                        clusters={{
                                            preset: "islands#redCircleIcon",
                                        }}
                                        features = {{type: "FeatureCollection", features: clusterList}}
                                        modules={[
                                            "objectManager.addon.objectsBalloon",
                                            "objectManager.addon.objectsHint",
                                        ]}
                                    />


                                    <div style={{position:"relative"}}>
                                        {searchItem()}
                                        {deliveryLogo()}
                                        {deliveryPoint()}

                                    </div>




                                    <ButtonWithYMap />
                                </Map>
                            </YMaps>

                        </div>


                    </div>

                </WaitLoader>

        </div>


    )
}